



























import Vue, { PropType } from 'vue';

export type dataType = {
  innerValue: number[];
};

export type OptionsType = {
  value: number;
  text: string;
};

export default Vue.extend({
  name: 'GMultiCheckbox',
  computed: {
    innerValue: {
      get(): number[] {
        return this.value;
      },
      set(val: number[]): void {
        this.$emit('input', val);
      },
    },
    innerOptions(): OptionsType[] {
      return this.options.map((o) => ({
        text: this.$t(o.text) as string,
        value: o.value,
      }));
    },
  },
  props: {
    value: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    options: {
      type: Array as PropType<OptionsType[]>,
      required: true,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
});
